/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SalesBaseService } from '../sales-base-service';
import { SalesApiConfiguration } from '../sales-api-configuration';
import { SalesStrictHttpResponse } from '../sales-strict-http-response';

import { SalesContractPaymentResponseDto } from '../models/sales-contract-payment-response-dto';
import { contractPaymentsControllerCreate } from '../fn/contract-payments/contract-payments-controller-create';
import { ContractPaymentsControllerCreate$Params } from '../fn/contract-payments/contract-payments-controller-create';
import { contractPaymentsControllerFindAllByTenant } from '../fn/contract-payments/contract-payments-controller-find-all-by-tenant';
import { ContractPaymentsControllerFindAllByTenant$Params } from '../fn/contract-payments/contract-payments-controller-find-all-by-tenant';
import { contractPaymentsControllerFindByContracts } from '../fn/contract-payments/contract-payments-controller-find-by-contracts';
import { ContractPaymentsControllerFindByContracts$Params } from '../fn/contract-payments/contract-payments-controller-find-by-contracts';
import { contractPaymentsControllerFindOne } from '../fn/contract-payments/contract-payments-controller-find-one';
import { ContractPaymentsControllerFindOne$Params } from '../fn/contract-payments/contract-payments-controller-find-one';
import { contractPaymentsControllerRemove } from '../fn/contract-payments/contract-payments-controller-remove';
import { ContractPaymentsControllerRemove$Params } from '../fn/contract-payments/contract-payments-controller-remove';
import { contractPaymentsControllerUpdate } from '../fn/contract-payments/contract-payments-controller-update';
import { ContractPaymentsControllerUpdate$Params } from '../fn/contract-payments/contract-payments-controller-update';

@Injectable({ providedIn: 'root' })
export class SalesContractPaymentsService extends SalesBaseService {
  constructor(config: SalesApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contractPaymentsControllerFindAllByTenant()` */
  static readonly ContractPaymentsControllerFindAllByTenantPath = '/o2-sales/contract-payments/{tenant}';

  /**
   * Retrieve contract payments by tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerFindAllByTenant()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerFindAllByTenant$Response(params: ContractPaymentsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>> {
    const obs = contractPaymentsControllerFindAllByTenant(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve contract payments by tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerFindAllByTenant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerFindAllByTenant(params: ContractPaymentsControllerFindAllByTenant$Params, context?: HttpContext): Observable<Array<SalesContractPaymentResponseDto>> {
    const resp = this.contractPaymentsControllerFindAllByTenant$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>): Array<SalesContractPaymentResponseDto> => r.body)
    );
  }

  /** Path part for operation `contractPaymentsControllerCreate()` */
  static readonly ContractPaymentsControllerCreatePath = '/o2-sales/contract-payments/{tenant}';

  /**
   * Create a new contract payment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerCreate$Response(params: ContractPaymentsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
    const obs = contractPaymentsControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a new contract payment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerCreate(params: ContractPaymentsControllerCreate$Params, context?: HttpContext): Observable<SalesContractPaymentResponseDto> {
    const resp = this.contractPaymentsControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractPaymentResponseDto>): SalesContractPaymentResponseDto => r.body)
    );
  }

  /** Path part for operation `contractPaymentsControllerFindByContracts()` */
  static readonly ContractPaymentsControllerFindByContractsPath = '/o2-sales/contract-payments/{tenant}/by-contracts';

  /**
   * Retrieve contract payments by multiple contract IDs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerFindByContracts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerFindByContracts$Response(params: ContractPaymentsControllerFindByContracts$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>> {
    const obs = contractPaymentsControllerFindByContracts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve contract payments by multiple contract IDs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerFindByContracts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerFindByContracts(params: ContractPaymentsControllerFindByContracts$Params, context?: HttpContext): Observable<Array<SalesContractPaymentResponseDto>> {
    const resp = this.contractPaymentsControllerFindByContracts$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<Array<SalesContractPaymentResponseDto>>): Array<SalesContractPaymentResponseDto> => r.body)
    );
  }

  /** Path part for operation `contractPaymentsControllerFindOne()` */
  static readonly ContractPaymentsControllerFindOnePath = '/o2-sales/contract-payments/{tenant}/id/{id}';

  /**
   * Retrieve a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerFindOne$Response(params: ContractPaymentsControllerFindOne$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
    const obs = contractPaymentsControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerFindOne(params: ContractPaymentsControllerFindOne$Params, context?: HttpContext): Observable<SalesContractPaymentResponseDto> {
    const resp = this.contractPaymentsControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractPaymentResponseDto>): SalesContractPaymentResponseDto => r.body)
    );
  }

  /** Path part for operation `contractPaymentsControllerRemove()` */
  static readonly ContractPaymentsControllerRemovePath = '/o2-sales/contract-payments/{tenant}/{id}';

  /**
   * Delete a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerRemove$Response(params: ContractPaymentsControllerRemove$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
    const obs = contractPaymentsControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractPaymentsControllerRemove(params: ContractPaymentsControllerRemove$Params, context?: HttpContext): Observable<SalesContractPaymentResponseDto> {
    const resp = this.contractPaymentsControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractPaymentResponseDto>): SalesContractPaymentResponseDto => r.body)
    );
  }

  /** Path part for operation `contractPaymentsControllerUpdate()` */
  static readonly ContractPaymentsControllerUpdatePath = '/o2-sales/contract-payments/{tenant}/{id}';

  /**
   * Update a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractPaymentsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerUpdate$Response(params: ContractPaymentsControllerUpdate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractPaymentResponseDto>> {
    const obs = contractPaymentsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a contract payment by tenant and ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contractPaymentsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractPaymentsControllerUpdate(params: ContractPaymentsControllerUpdate$Params, context?: HttpContext): Observable<SalesContractPaymentResponseDto> {
    const resp = this.contractPaymentsControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: SalesStrictHttpResponse<SalesContractPaymentResponseDto>): SalesContractPaymentResponseDto => r.body)
    );
  }

}
